import { addDays } from "date-fns";
import { useState } from "react";
import {
  Button,
  Confirm,
  useNotify,
  useRecordContext,
  useUpdate,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

const EXPIRES_AT_DATE_OFFSET = 2;

export const LandingDomainDeleteAfterButton = () => {
  const record = useRecordContext();
  const [update, { isPending }] = useUpdate();
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();

  const handleClick = () => setIsOpen(true);

  const handleClose = () => setIsOpen(false);

  const handleConfirm = () => {
    if (!record) {
      throw new Error(
        "LandingDomainDeleteAfterButton must be called with a RecordContext",
      );
    }

    const expiresAt = addDays(new Date(), EXPIRES_AT_DATE_OFFSET);

    void update(
      MODULE_NAMES.LANDING_DOMAINS,
      { id: record.id, data: { expiresAt: expiresAt.toISOString() } },
      {
        onSuccess: () => {
          notify(
            `Landing domain will be deleted in ${EXPIRES_AT_DATE_OFFSET} days`,
          );
        },
        onError: () => {
          notify("Error: can not delete the landing domain", { type: "error" });
        },
        onSettled: () => {
          handleClose();
        },
      },
    );
  };

  return (
    <>
      <Button disabled={isPending} onClick={handleClick}>
        Delete {EXPIRES_AT_DATE_OFFSET} days later
      </Button>
      <Confirm
        isOpen={isOpen}
        loading={isPending}
        onClose={handleClose}
        title={`Delete landing domain #${record?.id ?? ""}`}
        content={`Are you sure you want to delete this landing domain in ${EXPIRES_AT_DATE_OFFSET} days?`}
        onConfirm={handleConfirm}
      />
    </>
  );
};
